export default __webpack_public_path__ + "static/media/right-chart-template.png?.b7349578";